import { Component, OnInit } from '@angular/core';
import { TimelineService } from 'src/app/services/timeline.service';
import { ModalController } from '@ionic/angular';
import * as SFS2X from "sfs2x-api";
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account',
  templateUrl: './account.page.html',
  styleUrls: ['./account.page.scss'],
})
export class AccountPage implements OnInit {

  disableButtons = false;

  account;
  isLoggedIn = false;
  showingAccount: SFS2X.SFSUser;
  masculin;
  outlook;
  type;
  strength;
  dexternity;
  initiative;
  toughness;
  intelligence;
  leadership;
  karma;
  tired;
  condition;
  imageURL;
  imageTypeURL;
  hp;

  description;

  messages = [];

  constructor(private router: Router, public auth: AuthService,
              private modalCtrl: ModalController, public timelineService: TimelineService) {
/*
              if (this.auth.account.uid.length !== 28 && !this.auth.isLoggedIn)
              {
                console.log('get out');
              }
              else
              {
                console.log('id ok');
              }
              */
   }

  ngOnInit() {

    console.log('ngOnInit', this.auth.account.uid.length);

/*
    this.showingAccount = this.timelineService.showingAccount;
    if(!this.showingAccount) return;

    console.log('GOT account showingAccount?', this.showingAccount.getVariables());
    

    this.imageURL = this.showingAccount.getVariable('image').value;
    
    this.masculin = this.showingAccount.getVariable('masculin').value;
    this.outlook = this.showingAccount.getVariable('outlook').value;
    this.type = this.showingAccount.getVariable('type').value;
    this.imageTypeURL = this.timelineService.getMyType(this.type);
    
    this.strength = this.timelineService.getStrength(this.showingAccount.getVariable('strength').value, this.masculin);
    this.dexternity = this.timelineService.getDexternity(this.showingAccount.getVariable('dexternity').value, this.masculin);
    this.initiative = this.timelineService.getInitiative(this.showingAccount.getVariable('initiative').value, this.masculin);
    this.toughness = this.showingAccount.getVariable('toughness').value;
    this.intelligence = this.showingAccount.getVariable('intelligence').value;
    this.leadership = this.showingAccount.getVariable('leadership').value;
    this.karma = this.showingAccount.getVariable('karma').value;
    this.tired = this.showingAccount.getVariable('tired').value;
    this.condition = this.showingAccount.getVariable('condition').value;
    this.hp = this.showingAccount.getVariable('hp').value;


    let sumka = this.showingAccount.getVariable('strength').value + this.showingAccount.getVariable('dexternity').value + this.showingAccount.getVariable('initiative').value + this.toughness + this.intelligence + this.leadership;

    console.log('OPIS POSTACI ZA ILE?', sumka);

    if(sumka>350)
    {
      this.description = "Wygląda na kogoś, kto zwiedził cały Świat"
    }
    else
    {
      this.description = "Wygląda na doświadczoną osobę";
    }
    
    if(this.type=="robot")
    {
      this.description = "Najnowsza wersja robota szturmowego do tłumienia protestów i demonstracji."
    }

    */
  }

  

  async rozmawiaj()
  {
    console.log('rozmawiaj', this.showingAccount.name); 

    let msg = {
      image: this.imageURL,
      image2: this.timelineService.myOwnImage,
      name: this.outlook,
      text: "Zagadujesz do",
      subtype: "TALK"
    }

    this.messages.push(msg);

    //await this.awaitFunction(1300);


    let msg2 = {
      image2: this.imageURL,
      image: this.timelineService.myOwnImage,
      name: this.outlook,
      text: "nie ma Ci nic do powiedzenia.",
      subtype: "ANSWER"
    }

    this.messages.push(msg2);
  }

  async zapros()
  {
    console.log('zapros', this.showingAccount.name); 
    let msg = {
      image: this.imageURL,
      image2: this.timelineService.myOwnImage,
      name: this.outlook,
      text: "Zapraszasz do druzyny ",
      subtype: "INVITE"
    }

    this.messages.push(msg);

    // await this.awaitFunction(1500);

    let msg2 = {
      image2: this.imageURL,
      image: this.timelineService.myOwnImage,
      name: this.outlook,
      text: "odrzuca Twoje zaproszenie.",
      subtype: "ANSWER"
    }

    this.messages.push(msg2);
  }

  async steal()
  {
    console.log('steal', this.showingAccount.name); 

    let msg = {
      image: this.imageURL,
      image2: this.timelineService.myOwnImage,
      name: this.outlook,
      text: "Rozpoczynasz okradać ",
      subtype: "STEAL"
    }

    this.messages.push(msg);

    // await this.awaitFunction(1600);

    let msg2 = {
      image2: this.imageURL,
      image: this.timelineService.myOwnImage,
      name: this.outlook,
      text: "przyłapuje Cię od razu i porzucasz ten plan.",
      subtype: "ANSWER"
    }

    this.messages.push(msg2);
  }

  async attack()
  {
    console.log('attack', this.showingAccount.name); 

    let msg = {
      image: this.timelineService.myOwnImage,
      image2: this.imageURL,
      name: this.outlook,
      text: "Atakujesz ",
      subtype: "ATTACK"
    }

    this.messages.push(msg);

    this.disableButtons = true;
    
    // await this.awaitFunction(1700);

    var params = new SFS2X.SFSObject();
    params.putUtfString("attacked", this.showingAccount.name);
    params.putUtfString("roomName", this.timelineService.locationPage.zoneDataManager.actualRoomName);

    this.timelineService.appReference.sfs.send( new SFS2X.ExtensionRequest("attack", params) );
    this.timelineService.appReference.sfs.addEventListener(SFS2X.SFSEvent.EXTENSION_RESPONSE, this.onExtensionResponse, this);

    this.timelineService.iamFighting = true;

    this.modalCtrl.dismiss({
      'fightStart': true
    });
  }
  onExtensionResponse(evtParams) 
  {
      console.log("!!!!!--------ATTACK Result: onExtensionResponse" + evtParams.params);
  }

  closeModal()
  {

    this.modalCtrl.dismiss();
  }
}
